var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.SNightCardManagementPanel,{attrs:{"profile":_setup.getUserProfile,"info-link-url":_setup.nightCardProgramInfoUrl},on:{"populateUserProfileInfo":_setup.populateUserProfileInfo,"setGlobalLoading":_setup.setGlobalLoading}})
}
var staticRenderFns = []

export { render, staticRenderFns }